/**
 * Get PHPSESSID from URL parameter (preferred) or cookie (fallback)
 * @returns {string|null} The PHP session ID or null if not found
 */
export const getPhpSessionId = () => {
  if (typeof document === 'undefined') return null;

  // 1) Prefer URL parameter
  try {
    const url = new URL(window.location.href);
    const paramValue = url.searchParams.get('PHPSESSID');
    if (paramValue) return paramValue;
  } catch (_) {
    // ignore URL parsing errors
  }

  // 2) Fallback to cookie
  const name = 'PHPSESSID=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    const c = ca[i].trim();
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return null;
};

/**
 * Initialize session - log PHPSESSID from URL/cookie (call once on app load)
 */
export const initSession = () => {
  const sessionId = getPhpSessionId();
  //console.log('[sessionAuth] PHPSESSID from URL/COOKIES:', sessionId || 'NOT FOUND');
};


/**
 * Setup axios interceptor to inject X-PHPSESSID header from cookie
 * @param {axios instance} axiosInstance - The axios instance to configure
 */
export const setupSessionMiddleware = (axiosInstance) => {
  // Request interceptor
  axiosInstance.interceptors.request.use(
    (config) => {
      const configUrl = config.url || '';

      if (!configUrl.match(/^\/(api|companies|importControl|notification|importConfig|importSchedule|webhook|dashboard|globalConfig|upload)/)) {
        return config;
      }

      // Skip certain endpoints
      if (configUrl.includes('/webhook') || configUrl.includes('/api-docs') || configUrl.includes('/api-spec.json')) {
        return config;
      }

      const sessionId = getPhpSessionId();
      if (sessionId) {
        config.headers['X-PHPSESSID'] = sessionId;
        //console.log('[sessionAuth] Added X-PHPSESSID header:', sessionId.substring(0, 8) + '...');
      } else {
        console.error('[sessionAuth] ❌ NO PHPSESSID (URL param or cookie) for', configUrl);
      }


      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor for auth errors
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        console.warn('[sessionAuth] Auth failed - check PHPSESSID cookie');
        // Envia a mensagem para a janela que contém o iframe
        if (window.parent !== window) {
          window.parent.postMessage({
            type: 'AUTH_FAILURE',
            status: error.response.status,
            message: 'Session expired'
          }, '*'); // Em produção, substitua '*' pela URL real do seu portal PHP por segurança
        }
      }
      return Promise.reject(error);
    }
  );
};

export default {
  getPhpSessionId,
  initSession,
  setupSessionMiddleware
};


